module.exports = __webpack_public_path__ + "static/media/3-square-available.05cb8699.svg";